import * as React from "react";
const SvgFavoriteBorder = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M16.0003 6.55339C17.4537 4.84672 19.6803 3.76672 22.0003 3.76672C26.107 3.76672 29.3337 6.99339 29.3337 11.1001C29.3337 16.1359 24.8078 20.24 17.9506 26.4581L17.9337 26.4734L16.0003 28.2334L14.067 26.4867L14.0144 26.4389C7.17717 20.2257 2.66699 16.1272 2.66699 11.1001C2.66699 6.99339 5.89366 3.76672 10.0003 3.76672C12.3203 3.76672 14.547 4.84672 16.0003 6.55339ZM16.0003 24.6334L16.1337 24.5001C22.4803 18.7534 26.667 14.9534 26.667 11.1001C26.667 8.43339 24.667 6.43339 22.0003 6.43339C19.947 6.43339 17.947 7.75339 17.2537 9.58006H14.7603C14.0537 7.75339 12.0537 6.43339 10.0003 6.43339C7.33366 6.43339 5.33366 8.43339 5.33366 11.1001C5.33366 14.9534 9.52033 18.7534 15.867 24.5001L16.0003 24.6334Z",
	fill: "currentColor"
}));
export default SvgFavoriteBorder;
